<template>
<div>
	<v-content v-if="loaded">
		  <section class="divider-background">
					<div class="background-image-holder parallax-background">
						<div class="overlay background-dark-grey"></div>
                        <img alt="Divider Background" class="background-image" :src="bussiness.photo_url">
					</div>
						<v-row>
                            <v-col cols="12" class="medium-12 columns text-center">
							
								<div class="headline-style-2">
									<h3 class="text-white" v-html="bussiness.name" ></h3>
									<span class="sub-title text-white" v-html="bussiness.subtitle"></span>
									<div class="line"></div>
								</div>
                            </v-col>
						</v-row>
				  </section>
		<v-container>
			<v-row justify="center" align="start">
				<v-col cols="12" sm="8">

					<div v-for="category in categories" :key="category.id">
						<!-- recorrido padre : categories -->
						<h3>{{ category.name }} {{ category.subtitle}}</h3>

								<!-- recorrido hijos : category > Items -->
								<v-list three-line>
									<div v-for="item in items" :key="item.id">
										<v-list-item v-if="item.category_id === category.id">
											<v-list-item-content>
												<v-list-item-title v-text="item.name"></v-list-item-title>
												<v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
												<v-list-item-subtitle v-text="item.description1"></v-list-item-subtitle>
												<v-list-item-subtitle v-text="item.description2"></v-list-item-subtitle>
											<v-row  class=" px-2 ">
											<p   v-for="aler in  item.alergenos" :key="aler.id" > 
											<img style=" max-width: 24px; margin: 04px;" class="alergenos" :src="`/static/alergenos/${aler}.jpg`" />
											</p>
								
											</v-row>


											</v-list-item-content>
											<v-list-item-icon>
												<span v-text="item.price"></span>
												
											</v-list-item-icon>
											
										</v-list-item>
									</div>					
								</v-list>
										
					</div>
				</v-col>
			</v-row>

		</v-container>
	</v-content>

	 <section class="background-mid-grey pad-small">
					<v-row>
						
                        <v-col cols="4" class="medium-4 columns text-center">
							<v-icon >mdi-cellphone-text</v-icon>
							<h4> MENU-APP</h4>
								 <v-btn icon :to="`/i/${bussiness.id}`">
                           descargar
                            </v-btn>
						</v-col>

						<v-col cols="4" class="medium-4 columns text-center">
							<v-icon >mdi-phone-classic</v-icon>
							<h4>Reservas y pedidos</h4>
							<p v-html="bussiness.phone" >
							

							</p>
						</v-col>
                        <v-col cols="4" class="medium-4 columns text-center">
						
							<v-icon >mdi-map-marker</v-icon>
							<h4>Encuentranos</h4>
							<p v-html="bussiness.address" >
								

							</p>
						</v-col>
					</v-row>
				  </section>

	        <footer class="footer-text">
					<v-row>
						<v-col class="medium-12 columns text-center">

						<a href="https://uebs.net">	<span>© Copyright 2020 - All Rights Reserved - powered by UEBS APPS LAB SL </span></a>
						</v-col>
					</v-row>
				  </footer>


	</div>
</template>

<script>
	import {db} from '@/main';
	export default {
		name: 'landing',
		mounted(){
			//console.log(this.$route.params.id)
			if ( this.$route.params.id == null ) { this.$router.push('/') }
			this.getBussiness(this.$route.params.id)
			if (this.bussiness !== '' ) {
				this.getCategories(this.$route.params.id)
				this.getItems(this.$route.params.id)
			}

		},
		data: () => ({
			loaded: false,
			bussiness: {},
			categories: [],
			items: []
		}),
		methods: {
			// Busco el negocio
			async getBussiness(bussiness_id){
				await db.collection('bussiness').doc(bussiness_id)
				  .get()
					.then( (snap) => {
							if (snap.exists) {
								this.bussiness = snap.data()
							} else {
								this.$router.push('/')
							}
					})
			}, //.getBusiness

			// Busco las categorias y las cargo en el array categories
			async getCategories(bussiness_id){
				let cats = []
				await db.collection('bussiness').doc(bussiness_id)
					.collection('categories').where('visible','==', true).orderBy('order')
					.onSnapshot(snap => {
						snap.forEach(doc => {
							cats.push({ id: doc.id, ...doc.data() })
						})
						this.categories = cats;
					})

			}, //.getCategories

			// Busco los items y los cargo en el array item
			async getItems(bussiness_id){
				let its = []
				await db.collection('bussiness').doc(bussiness_id)
					.collection('items').where('visible','==', true).orderBy('order')
					.onSnapshot(snap => {
						snap.forEach(doc => {
							its.push({ id: doc.id, ...doc.data() })
						})
						this.items = its;
						this.loaded = true;
					})

			}, //.getCategories



		} //.methods



		
	}
</script>

<style scoped>

a:link, a:visited, a:active {
    text-decoration:none;
}
	font {
		font-family: 'Roboto', sans-serif;
		font-weight: 400;
		line-height: normal !important;
	}
		.font_s {
		font-family: 'Roboto', sans-serif;
		font-weight: 200;
		line-height: normal !important;
    }
    .background-image {

 width: inherit;

    }


       
/**** GLOBAL STYLES ****/

body{ font-family: 'Raleway',"Helvetica Neue", "Helvetica", Helvetica, Arial, sans-sub-title; color: #777777; -webkit-font-smoothing: antialiased; }
ul{ list-style: none; margin: 0px; }
hr{ margin: 33px 0px; border-color: #e1e1e1; }
.background-highlight{ background: #f5f5f5; }
a:focus{ color: #ddd; }
.button:hover{ color: #fff; }

.main-container{ position: relative; -webkit-transition: all .5s ease; transition: all .5s ease; -moz-transition: all .5s ease; -webkit-transform: translate3d(0,0,0); -moz-transform: translate3d(0,0,0); transform: translate3d(0,0,0); overflow: hidden;   }

/* LIFE EASIER-ERERS */

.offix{ overflow: hidden; }
.block{ display: block; }

.left-align{ left: 0; }
.right-align{ right: 0; }

/***** TYPOGRAPHY *****/

h1, h2, h3, h4, h5, h6{ font-family: 'Nixie One','Raleway',"Helvetica Neue", "Helvetica", Helvetica, Arial, sans-sub-title; color: #333333; font-weight: 300; text-transform: uppercase;  }
h3{ font-size: 30px; margin-bottom: 33px; }

p{ font-size: 14px; line-height: 26px; }
p:last-child{ margin-bottom: 0px; }
p.lead{ font-size: 26px; color: #333; line-height: 35px; margin-bottom: 22px; }

.sub-title{ text-transform: uppercase; font-weight: bold; letter-spacing: 3px; font-size: 12px; display: inline-block; color: #333333; }
.text-white{ color: #fff; }

.icon-large{ font-size: 33px; display: inline-block; margin-bottom: 22px; }

a.large-link{ font-size: 13px; border-bottom: 1px solid; letter-spacing: 3px; font-weight: bold; padding-bottom: 4px; text-transform: uppercase; margin-bottom: 7px; }

/* TITLE STYLES */

.page-title{ margin-bottom: 66px; }

.title-style-1 span{ text-transform: uppercase; font-size: 22px; color: #333; }
.title-style-1 .span-holder{ padding: 11px; border: 2px solid; background: #fff; position: relative; z-index: 2; display: inline-block; }
.title-style-1 h3{ margin: 0px; line-height: 1; }

/***** COLORS *****/

.background-dark-grey{ background: #333333; }
.background-mid-grey{ background: #f2f2f2; }
a {color: #797979;}

/***** SPACING *****/

section{ padding-top: 99px; padding-bottom: 111px; position: relative; z-index: 2; background: #fff; }
.pad-small{ padding-top: 66px; padding-bottom: 66px; }
.pad-large{ padding: 250px 0px !important; }
.pad-small-bottom{ padding-bottom: 77px; }

.push-small{ margin-bottom: 11px; }
.push-large{ margin-bottom: 44px; }

.no-left-pad{ padding-left: 0px !important; }
.no-right-pad{ padding-right: 0px !important; }

/***** BUTTONS *****/

.button{ display: inline-block; background: #444; border-radius: 25px; line-height: 1; padding: 13px 37px 14px 37px; margin-top: 22px; text-transform: uppercase; color: #fff; font-size: 12px; font-weight: bold; -webkit-user-select: auto !important; }




/***** SLIDERS & DIVIDERS *****/

.hero-slider{ padding: 0px; position: relative; display: block; z-index: 1; overflow: hidden; }
.flex-fix{ z-index: 100000 !important; }

.overlay{ position: absolute; width: 100%; height: 100%; opacity: 0.96; z-index: 1; top: 0px; }

.hero-slider .slides li{ background-size: cover !important; position: relative; height: 800px; }
.slides li .row{ position: relative; z-index: 2; }

.gallery-slider{ padding: 0px; }
.gallery-slider .slides li{ height: 550px; background-size: cover !important; }

.divider-background{ padding: 150px 0px; background-size: cover !important; overflow: hidden; }
.divider-background .row{ position: relative; z-index: 2; }

.background-image-holder{ position: absolute; width: 100%; height: 160%; z-index: 0; background-size: cover !important; top: -20%; }
.hero-slider .background-image-holder{ height: 102%; top: 0px;   }

/* Slider Headline Styles */

.headline-style-1{ display: inline-block; }
.headline-style-1 h1{ font-size: 120px; line-height: 1; font-family: 'Kristi','Nixie One','Raleway',"Helvetica Neue", "Helvetica", Helvetica, Arial, sans-sub-title; text-transform: lowercase; }
.headline-style-1 .sub-title{ display: inline-block; font-size: 13px; letter-spacing: 7px; margin-right: -7px; }
.headline-style-1 img{  display: inline-block; margin-bottom: 22px; }

.headline-style-2{ display: inline-block; }
.headline-style-2 h3{ margin-bottom: 0px; font-size: 110px; font-family: 'Kristi','Nixie One','Raleway',"Helvetica Neue", "Helvetica", Helvetica, Arial, sans-sub-title; text-transform: lowercase; line-height: 130px; }
.headline-style-2 .sub-title{ letter-spacing: 8px; margin-right: -8px; }
.headline-style-2 .line{ height: 2px; background: #fff; width: 80px; margin: 0px auto; margin-top: 34px; }

/***** TEXT SECTION *****/

.no-pad{ padding: 0px; overflow: hidden; }

.photo-container{ position: absolute; height: 100%; top: 0px;  }
.no-pad .columns{ padding: 88px 0px 99px 0px; }
.no-pad p.columns{ padding: 0px 15px; }
.no-pad .columns hr{ border-color: #aaa; }



/***** FOOTERS *****/

.footer-container{ -webkit-transition: all .5s ease; transition: all .5s ease; -moz-transition: all .5s ease; -webkit-transform: translate3d(0,0,0); -moz-transform: translate3d(0,0,0); transform: translate3d(0,0,0); position: relative; }

footer{ background: #333; padding: 88px 0px; }

.footer-text h6{ color: #8e8e8e; font-size: 12px; font-weight: bold; margin-bottom: 22px; font-family: 'Raleway',"Helvetica Neue", "Helvetica", Helvetica, Arial; }
.footer-text span{ font-size: 11px; color: #727272; text-transform: uppercase; font-weight: bold; }





</style>